import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.geo-raster-image-aws-uploader', () => {
  void import('./internal/geo-raster-image-aws-uploader')
    .then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.ndvi-function', () => {
  void import('./internal/ndvi-function').then(({ default: Component }) => Component());
});
